import api from '../../../utils/functions/api';

// โหมดคำนวณค่าออกสนามต่องวด — ใช้เฉพาะงวดที่ยังไม่ได้ "บันทึกเงินเดือน" (ดู
// salaryListCheckPeriod สำหรับเช็คว่างวดล็อกหรือยัง) mirror pattern เดียวกัน
// ไม่ผ่าน reducer เพราะ caller ใช้ผลลัพธ์ตรงๆ เป็น local state ของหน้า ไม่ต้องแชร์ผ่าน redux
export const fieldAllowanceCalcModeGet = ({ dateStart, dateEnd, role_type = '' }) => async () => {
  const { data } = await api.get(
    `${process.env.REACT_APP_API_URL}/field-allowance-calc-mode?dateStart=${dateStart}&dateEnd=${dateEnd}&role_type=${role_type}`,
  );
  return data;
};

export const fieldAllowanceCalcModeSet = ({
  dateStart, dateEnd, role_type = '', mode,
}) => async () => {
  const { data } = await api.put(
    `${process.env.REACT_APP_API_URL}/field-allowance-calc-mode`,
    { dateStart, dateEnd, role_type, mode },
  );
  return data;
};
